import { Controller } from "stimulus"

// #1914: de volgorde van de widgets op het telefoondashboard. Slepen aan de
// greep werkt met de vinger (pointer events; HTML-slepen werkt op een
// telefoon niet), de pijltjes werken altijd. Er wordt niets direct bewaard:
// de verborgen velden staan in de nieuwe volgorde en Opslaan stuurt ze mee.
export default class extends Controller {
  static targets = ["item"]

  omhoog(event) {
    const item = event.currentTarget.closest("[data-widget-volgorde-target='item']")
    const vorige = item?.previousElementSibling
    if (vorige) item.parentNode.insertBefore(item, vorige)
    event.currentTarget.focus()
  }

  omlaag(event) {
    const item = event.currentTarget.closest("[data-widget-volgorde-target='item']")
    const volgende = item?.nextElementSibling
    if (volgende) item.parentNode.insertBefore(volgende, item)
    event.currentTarget.focus()
  }

  pak(event) {
    const item = event.currentTarget.closest("[data-widget-volgorde-target='item']")
    if (!item) return

    event.preventDefault()
    this.gesleept = item
    item.classList.add("is-sleept")
    this.beweeg = (e) => this.verplaats(e)
    this.los = () => this.laatLos()
    window.addEventListener("pointermove", this.beweeg, { passive: false })
    window.addEventListener("pointerup", this.los, { once: true })
    window.addEventListener("pointercancel", this.los, { once: true })
  }

  verplaats(event) {
    if (!this.gesleept) return
    event.preventDefault()

    const y = event.clientY
    const anderen = this.itemTargets.filter((item) => item !== this.gesleept)
    const doel = anderen.find((item) => {
      const rect = item.getBoundingClientRect()
      return y < rect.top + rect.height / 2
    })
    const lijst = this.gesleept.parentNode
    if (doel) {
      if (doel !== this.gesleept.nextElementSibling) lijst.insertBefore(this.gesleept, doel)
    } else if (lijst.lastElementChild !== this.gesleept) {
      lijst.appendChild(this.gesleept)
    }
  }

  laatLos() {
    if (!this.gesleept) return
    this.gesleept.classList.remove("is-sleept")
    this.gesleept = null
    window.removeEventListener("pointermove", this.beweeg)
  }

  disconnect() {
    this.laatLos()
  }
}
